/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchInterviewLogs } from "./InterviewLogsApi";

const initialState: any = {
  loading: {
    fetchInterviewLogs: false,
  },
  req_success: {
    fetchInterviewLogs: false,
  },
  interviewLogs: [],
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 1,
  stats: {
    totalInterviews: 0,
    uniqueUsers: 0,
    completedInterviews: 0,
    avgPerformance: 0,
  },
};

const InterviewLogsSlice = createSlice({
  name: "interviewLogs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // FETCH INTERVIEW LOGS
    builder.addCase(fetchInterviewLogs.pending, (state) => {
      state.loading.fetchInterviewLogs = true;
      state.req_success.fetchInterviewLogs = false;
    });
    builder.addCase(
      fetchInterviewLogs.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.fetchInterviewLogs = false;
        state.req_success.fetchInterviewLogs = true;
        state.interviewLogs = payload?.data || [];
        state.total = payload?.total || 0;
        state.page = payload?.page || 1;
        state.limit = payload?.limit || 10;
        state.totalPages = payload?.totalPages || 1;
        state.stats = payload?.stats || {
          totalInterviews: 0,
          uniqueUsers: 0,
          completedInterviews: 0,
          avgPerformance: 0,
        };
      }
    );
    builder.addCase(fetchInterviewLogs.rejected, (state) => {
      state.loading.fetchInterviewLogs = false;
      state.req_success.fetchInterviewLogs = false;
    });
  },
});

export default InterviewLogsSlice.reducer;

